import { useAppSelector } from '@redux/hooks';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import { useState } from 'react';

import { getBanners } from '../../module/selectors/getBanners';

import classNames from 'classnames';
import { NavigationBar } from './NavigationBar';
import { SliderBanner } from './SliderBanner';
import { TypeProps } from './TypeProps';

import styles from './Banner.module.scss';

export const Banner = ({ refBlock, className, children, ...props }: TypeProps): JSX.Element => {
  const [active, setActive] = useState<number>(null);
  const banners = useAppSelector(getBanners);

  if (!banners || !banners?.length) {
    return <>{children}</>;
  }

  return (
    <ErrorBoundaryComponent>
      <div ref={refBlock} className={classNames(styles.Banner, className)} {...props}>
        <SliderBanner list={banners} active={active} />
        {banners?.length > 1 && <NavigationBar countAll={banners?.length} active={active === null ? 0 : active} setActive={setActive} />}
      </div>
    </ErrorBoundaryComponent>
  );
};
